"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndoOp = void 0;
const MutationOp_1 = require("./MutationOp");
class UndoOp extends MutationOp_1.MutationOp {
    constructor(target, targetOp, cascadeOf) {
        super(target);
        if (targetOp instanceof UndoOp) {
            throw new Error("And undo op can't be undone this way, please just re-issue the original op");
        }
        if (targetOp !== undefined) {
            this.targetOp = targetOp;
        }
        if (cascadeOf !== undefined) {
            this.cascadeOf = cascadeOf;
        }
    }
    getClassName() {
        return UndoOp.className;
    }
    init() {
    }
    getTargetOp() {
        return this.targetOp;
    }
    literalizeInContext(context, path, flags) {
        if (flags === undefined) {
            flags = [];
        }
        flags.push('undo');
        return super.literalizeInContext(context, path, flags);
    }
}
exports.UndoOp = UndoOp;
UndoOp.className = 'hhs/v0/UndoOp';
//# sourceMappingURL=UndoOp.js.map